import * as categoriesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    isCategoriesFetching: false,
    errorMessage: '',
    listAllCategories: null,
};

export const categoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case categoriesActions.IS_CATEGORIES_FETCHING:
            return {
                ...state,
                errorMessage: action.errorMessage,
            };

        case categoriesActions.CATEGORIES_FETCHING_ERROR:
            return {
                ...state,
                isCategoriesFetching: action.value,
            };

        case categoriesActions.GET_ALL_CATEGORIES:
            return {
                ...state,
                listAllCategories: action.listCategories,
            };

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/categories/reducer.js